module.exports = __webpack_public_path__ + "static/media/jeffhuang_headshot_2024_compressed.a7748d61.jpg";